import { SwitchWithLoading } from 'src/components/SwitchWithLoading/SwitchWithLoading';
import {
  useAssignProjectKnowledgeBaseMutation,
  useGetProjectByIdQuery,
  useUnassignProjectKnowledgeBaseMutation,
} from 'src/services';
import { useParams } from 'react-router-dom';
import { ProductsTypeBack } from 'src/constants/products';
import type { KnowledgeBase } from 'src/services/knowledgeBaseService';

export const UsedExistingKBAccordionItem = ({ item }: { item: KnowledgeBase }) => {
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const [assignKB, { isLoading: assignKBisLoading }] = useAssignProjectKnowledgeBaseMutation();
  const [unassignKB, { isLoading: unassignKBIsLoading }] =
    useUnassignProjectKnowledgeBaseMutation();
  const isChecked = item.projects.some((project) => project.id === +id);

  const onCheckedChange = (val: boolean) => {
    const request = {
      project_type: ProductsTypeBack[currentProject?.project_type],
      projectId: currentProject.id,
      body: [item.id],
    };

    val ? assignKB(request) : unassignKB(request);
  };

  return (
    <div
      className={
        'flex flex-row items-center justify-between bg-white border border-[#B8C1C633] rounded-sm-5 p-5'
      }
    >
      <p className={'text-ebony_opacity_80 font-medium text-sm'}>{item.name}</p>
      <SwitchWithLoading
        isLoading={assignKBisLoading || unassignKBIsLoading}
        defaultChecked={isChecked}
        onCheckedChange={(val) => onCheckedChange(val)}
      />
    </div>
  );
};
